/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-foto[_ngcontent-%COMP%]{width:134px;height:178px;padding:5px;border:2px solid #eef;margin-bottom:5px}.box-foto[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:121px;height:162px}.foto-lista[_ngcontent-%COMP%]{width:40px;height:40px}th[_ngcontent-%COMP%]{text-align:center}.desativado[_ngcontent-%COMP%]{background-color:#dd4b39;color:#fff;text-align:center;padding:5px;width:100%;margin:0 15px 7px}"];
export { styles as styles };
